import {styled} from '@linaria/react';
import React from 'react';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';

interface SectionFooterProps {
  label: string;
  url: string;
  onLinkItemClick?: () => void;
  dataTestId?: string;
  className?: string;
}

export const SectionFooter: React.FC<SectionFooterProps> = ({
  label,
  url,
  onLinkItemClick,
  dataTestId = 'sectionFooter',
  className,
}) => {
  if (!url) {
    return null;
  }

  return (
    <Wrapper
      title={label}
      onClick={onLinkItemClick}
      to={url}
      data-testid={dataTestId}
      className={className}
    >
      {label}
      <RightIcon asset={GenericIconName.ArrowRight} size="XXS" />
    </Wrapper>
  );
};

const RightIcon = styled(Icon)`
  margin-left: 8px;
  opacity: 1;
  transition: opacity 0.3s ease;
`;

const Wrapper = styled(UnstyledLinkLinaria)`
  display: flex;
  align-items: center;
  font-size: ${FONT_SIZES.px12};
  margin-top: 20px;
  margin-bottom: 3px;

  &:hover {
    font-weight: ${FONT_WEIGHTS.bold};
    letter-spacing: 0.005em;

    ${RightIcon} {
      opacity: 1;
    }
  }
`;
